import {
  type OauthToken,
  createFetchClient,
  createOauthProvider,
  loggerAfterHandler,
} from "@krainovsd/js-helpers";
import { ENDPOINTS } from "./endpoints";

export const OAUTH_PROVIDER = createOauthProvider({
  tokenRequest: getToken,
  forceSetToken: true,
  refreshToken: true,
  subWindow: false,
  waitSubWindow: 20000,
});

export async function getToken() {
  try {
    const response = await fetch(ENDPOINTS.token);
    if (response.ok) {
      return (await response.json()) as OauthToken;
    }
    throw new Error(`bad request status ${response.status}`);
  } catch (error) {
    console.error(error);
  }
}

const apiClient = createFetchClient({
  client: window.fetch.bind(window),
  afterHandlers: [
    loggerAfterHandler({
      filterStatus(status) {
        return status >= 400;
      },
    }),
  ],
  beforeHandlers: [OAUTH_PROVIDER.beforeHandlerCheckExpires, OAUTH_PROVIDER.beforeHandlerSetToken],
  refetchAfterAuth: OAUTH_PROVIDER.refetchAfterRefreshFlow,
});

export const apiRequest = apiClient.requestWithArrayResponse;
